<template>
  <div class="signup-proxy-wrapper">
    <div v-if="flag == 0">
      <div class="signup-proxy p-4">
        <div class="work-card mb-6" v-for="(item, index) in taskData" :key="index" v-loading="cardLoading">
          <div class="top-content flex justify-between items-center bg-card-bg-gray p-4 pt-2">
            <!-- 左边文字 -->
            <div class="left-content">
              <div>
                <div class="text-medium-x font-bold inline-block left-name">{{ item.name }}</div>
                <div class="inline-block mx-1 status-text">
                  <div v-if="item.status == 100" class="" style="background: #00be6a"><span>审核中</span></div>
                  <div v-if="item.status == 200" class="" style="background: #e8a31b"><span>招募中</span></div>
                  <div v-if="item.status == 300" class="" style="background: #e34152"><span>审核拒绝</span></div>
                  <div v-if="item.status == 400" class="" style="background: #6c748a"><span>报名结束</span></div>
                </div>
              </div>
              <div class="mt-2 text-medium" style="color: rgba(0, 0, 0, 0.65)">
                <span class="mr-8">报名数：{{ item.joinQuantity }}</span>
                <span class="mr-8">已选中：{{ item.selectedQuantity }}</span>
                <span>待处理：{{ item.unselectedQuantity }}</span>
              </div>
            </div>
            <!-- 右边按钮 -->
            <div class="right-content">
              <el-button type="text" @click="recruitInfo(item)">招募信息</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="closeProxy(item.id)" v-if="item.status == 200">关闭招募</el-button>
            </div>
          </div>
          <div class="p-4">
            <!-- 搜索框和下拉框 -->
            <div class="input-group mb-2">
              <el-input
                placeholder="代理名称"
                v-model="item.proxyName"
                :style="{ width: '128px' }"
                @keyup.enter.native="toSearch(item)"
              >
              </el-input>
              <el-input
                placeholder="联系方式"
                v-model="item.proxyContact"
                :style="{ width: '128px' }"
                @keyup.enter.native="toSearch(item)"
              >
              </el-input>
              <el-select v-model="item.selectedStatus" placeholder="状态" :style="{ width: '128px' }">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
              <div class="inline-block" style="width: 140px">
                <el-button class="mr-0.5" type="primary" @click="toSearch(item)">
                  <span class="px-0.5">查询</span>
                </el-button>
                <el-button size="small" @click="onReset(item)">
                  <span class="px-0.5">重置</span>
                </el-button>
              </div>
            </div>
            <!-- table -->
            <div class="bottom-table">
              <el-table
                class="data-table mb-3"
                :data="item.agencyList"
                style="width: 100%"
                @selection-change="selectionChangeHandler(item.id)"
                :ref="item.id"
              >
                <el-table-column type="selection" :selectable="selectableHandler"> </el-table-column>
                <el-table-column prop="name" label="代理名称" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.name ? scope.row.name : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="contact" label="联系方式" align="center"> </el-table-column>
                <el-table-column prop="shopHasProxyJobCreateAt" label="报名时间" align="center"> </el-table-column>
                <el-table-column prop="shopHasProxyJobStatus" label="状态" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.shopHasProxyJobStatus == '100'">
                      <span class="mr-0.5" style="color: rgba(0, 0, 0, 0.15)">●</span>
                      <span style="color: #6c748a">未处理</span>
                    </div>
                    <div v-else-if="scope.row.shopHasProxyJobStatus == '200'">
                      <span class="mr-0.5" style="color: #00be6a">●</span>
                      <span style="color: #00be6a">已选中</span>
                    </div>
                    <div v-else-if="scope.row.shopHasProxyJobStatus == '300'">
                      <span class="mr-0.5" style="color: #e34152">●</span>
                      <span style="color: #e34152">已淘汰</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="option" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="distributeWork(item, 'single', scope.row)"
                      v-if="scope.row.shopHasProxyJobStatus == 100 || scope.row.shopHasProxyJobStatus == 200"
                      >分配任务</el-button
                    >
                    <el-button
                      type="text"
                      @click="outInterviewer(item.id, scope.row)"
                      v-if="scope.row.shopHasProxyJobStatus == 100"
                      >淘汰</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="primary" class="distribute" @click="distributeWork(item.id, 'many', item)">分配任务</el-button>
            </div>
          </div>
        </div>
        <!-- 查看招募信息的 dialog -->
        <el-drawer
          title="招募信息"
          :visible.sync="recruitInfoDialogVisible"
          size="60%"
          :destroy-on-close="true"
          :before-close="handleClose"
        >
          <div v-loading="dialogLoading" class="flex flex-col pb-4" style="min-height: calc(100vh - 114px)">
            <div class="px-6 pt-6">
              <div class="dialog-content-top">
                <div class="content-top-title font-bold flex justify-between text-medium-x text-theme-black-850">
                  <div style="width: 86%">{{ currentProxyTaskDetail.name }}</div>
                  <div class="imgDiv">
                    <img src="@/assets/img/random-interview/shenhe.png" v-if="currentTaskStatus == 100" />
                    <img src="@/assets/img/random-interview/doing.jpg" v-else-if="currentTaskStatus == 200" />
                    <img src="@/assets/img/random-interview/refuse.jpg" v-else-if="currentTaskStatus == 300" />
                    <img src="@/assets/img/random-interview/end.jpg" v-else-if="currentTaskStatus == 400" />
                  </div>
                </div>
                <div class="content-top-info">
                  <el-row>
                    <el-col :span="13"
                      ><div class="grid-content"><span>任务截止时间：</span>{{ currentProxyTaskDetail.endAt }}</div></el-col
                    >
                    <el-col :span="11"
                      ><div class="grid-content"><span>报名截止时间：</span>{{ currentProxyTaskDetail.joinEndAt }}</div></el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="24"
                      ><div class="grid-content wj-count">
                        <span>问卷题目数：</span>{{ currentProxyTaskDetail.titleAmount }}
                      </div></el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="24"
                      ><div class="grid-content work-detail">
                        <span>任务描述：</span>{{ currentProxyTaskDetail.describe }}
                      </div></el-col
                    >
                  </el-row>
                </div>
              </div>

              <div class="dialog-content-bottom">
                <div class="content-bottom-title flex justify-between items-center">
                  <div class="font-bold text-medium-x text-theme-black-850 mb-3">工作地区（最多可选择5个地区）</div>
                  <div>
                    <span class="text-medium text-theme-black-850"
                      ><span class="text-theme-black-450">任务总价（元）：</span>{{ currentProxyTaskDetail.totalPrice }}</span
                    >
                    <span class="ml-6 text-medium text-theme-black-850"
                      ><span class="text-theme-black-450">任务总数量：</span>{{ currentProxyTaskDetail.totalAmount }}</span
                    >
                  </div>
                </div>

                <div class="content-bottom-table">
                  <el-table class="data-table" :data="currentProxyTaskDetail.workArea" style="width: 100%">
                    <el-table-column prop="serialNo" label="序号" align="center"> </el-table-column>
                    <el-table-column prop="name" label="工作地区" align="center"> </el-table-column>
                    <el-table-column prop="amount" label="数量" align="center"> </el-table-column>
                    <el-table-column prop="price" label="单价" align="center"> </el-table-column>
                    <el-table-column prop="note" label="备注" align="center"> </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-footer">
            <el-button @click="changeProxyInfo">修改信息</el-button>
            <el-button type="primary" @click="recruitInfoDialogVisible = false" style="width: 88px">关闭</el-button>
          </div>
        </el-drawer>

        <!-- 修改招募信息的dialog -->
        <el-dialog
          title="招募信息修改"
          class="theme-dialog dialog-center dialog-body-0"
          top="0"
          :visible.sync="changeProxyInfoDialogVisible"
          :before-close="handleChangeProxyInfoClose"
          :destroy-on-close="true"
          width="80%"
        >
          <recruitment-form :id="Number(currentProxyTaskDetail.id)" :pageType="'proxy'" @cancel="handleChangeProxyInfoClose" />
        </el-dialog>
      </div>
    </div>

    <div v-else-if="flag == 1" class="mt-4">
      <!-- 分配任务 -->
      <assign-proxy-task @comeback="comebackHandler" :data="selectioned" :title="title" :id="recruitTaskId" />
    </div>

    <div v-else-if="flag == 2">
      <el-empty class="pt-40" description="目前暂无招募任务信息"></el-empty>
    </div>
  </div>
</template>

<script>
import assignProxyTask from './AssignProxyTask.vue'
import recruitmentForm from '@/views/survey/offline/components/RecruitmentForm'
import {
  getAgencyTaskList,
  getAgencyTaskAgents,
  agencyWeedOut,
  closeAgencyTask,
  getAgencyTaskDetail
} from '@/api/wenjuan/offline.js'
import GlobalConfig from '@/global/config'

export default {
  name: 'SignupProxy',
  components: {
    assignProxyTask,
    recruitmentForm
  },
  data() {
    return {
      selectioned: new Map(),
      title: '', // 保存招募任务的标题
      curId: '', // 当前招募详情id
      currentTaskStatus: '', // 点击了招募信息后 保存一下当前任务的状态
      currentTaskInfo: '', // 点击分配任务 保存当前招募任务信息
      dialogLoading: false,
      cardLoading: false,
      flag: 0,
      // interviewerName: '',
      // interviewerPhone: '',
      recruitTaskId: '', // 招募任务id 用于传给分配任务组件用
      recruitInfoDialogVisible: false, // 查看招募信息框
      changeProxyInfoDialogVisible: false, // 修改招募信息框
      currentProxyTaskDetail: {},
      // sex: '',
      // area: '',
      // age: '',
      // status: '',
      taskData: '',
      statusOptions: [
        {
          label: '未处理',
          value: 100
        },
        {
          label: '已选中',
          value: 200
        },
        {
          label: '已淘汰',
          value: 300
        }
      ]
    }
  },
  created() {
    this.getTaskData()
    this.handlerSum()
  },
  methods: {
    async getTaskData() {
      this.taskData = []
      let res = await getAgencyTaskList({
        surveyId: GlobalConfig.getSurveyId()
      })
      // console.log('报名的代理数据：', res.data.data);

      if (!res.data.data) {
        this.flag = 2
        return
      }
      this.taskData =
        res.data.data &&
        res.data.data.map(item => {
          item.proxyName = ''
          item.proxyContact = ''
          item.selectedStatus = ''
          return item
        })

      this.handlerSum()
    },
    handleClose() {
      this.recruitInfoDialogVisible = false
    },
    // 【招募信息按钮】
    recruitInfo(item) {
      this.dialogLoading = true
      this.recruitInfoDialogVisible = true

      // 保存一下当前招募任务的状态
      this.currentTaskStatus = item.status
      this.curId = item.id
      this.getProxyTaskDetail()
    },
    getProxyTaskDetail() {
      getAgencyTaskDetail({ id: this.curId })
        .then(res => {
          this.currentProxyTaskDetail = res.data.data
          this.currentProxyTaskDetail.totalPrice = this.currentProxyTaskDetail.totalAmount = 0
          if (res.data.data.workArea.length !== 0) {
            res.data.data.workArea.forEach(item => {
              this.currentProxyTaskDetail.totalAmount += item.amount
              this.currentProxyTaskDetail.totalPrice += item.amount * item.price
            })
          }
        })
        .catch(e => {
          this.$message.error(`查询详细信息失败 ${e.message}`)
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },
    // 分配任务
    distributeWork(id, ...end) {
      this.recruitTaskId = ''
      this.title = ''
      if (end[0] == 'many') {
        if (!this.$refs[id][0].selection.length) {
          this.$message.error('请勾选当前招募任务下的调查员！')
          return
        }
        this.selectioned.clear()
        this.$refs[id][0].selection.forEach(item => {
          this.selectioned.set(item.contact, item)
        })

        this.title = end[1].name
        this.recruitTaskId = id
      } else if (end[0] == 'single') {
        this.selectioned.clear()
        this.title = id.name
        this.recruitTaskId = id.id
        this.selectioned.set(end[1].contact, end[1])
        // console.log(end[1]);
      }
      // 切换到分配任务组件
      this.flag = 1
    },
    comebackHandler() {
      this.getTaskData()
      this.flag = 0
    },
    // 修改招募信息
    changeProxyInfo() {
      this.changeProxyInfoDialogVisible = true
    },
    // 修改招募信息框的关闭处理函数
    handleChangeProxyInfoClose() {
      this.changeProxyInfoDialogVisible = false
      this.getProxyTaskDetail()
    },
    // 关闭招募按钮处理函数
    closeProxy(id) {
      this.cardLoading = true
      closeAgencyTask({ id })
        .then(res => {
          this.getTaskData()
          this.$message.success('关闭招募成功！')
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.cardLoading = false
        })
    },
    // 淘汰调查员函数
    outInterviewer(proxyJobId, row) {
      agencyWeedOut({ shopId: row.id, proxyJobId })
        .then(res => {
          if (res.data.code == 0) {
            // 将本地的状态改变 不调用接口 因为成功了 这个地方肯定是300 也就不用刷新页面了 好的用户体验
            row.shopHasProxyJobStatus = 300
            this.handlerSum()
            this.$message.success('淘汰调查员成功！')
            // this.getTaskData();
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(e => {
          this.$message.error(`淘汰失败 ${e.message}`)
        })
    },
    // 选中项变化触发的函数
    selectionChangeHandler(id) {},
    toSearch(item) {
      this.inputValueChangeHandler(item)
    },
    onReset(item) {
      item.proxyName = ''
      item.proxyContact = ''
      item.selectedStatus = ''
      this.toSearch(item)
    },
    // 选择条件变化触发的函数
    inputValueChangeHandler(item) {
      let params = {
        taskId: item.id
      }
      item.proxyName && (params.name = item.proxyName)
      item.proxyContact && (params.phone = item.proxyContact)
      item.selectedStatus && (params.shopHasProxyJobStatus = item.selectedStatus)

      getAgencyTaskAgents(params)
        .then(res => {
          item.agencyList = res.data.data
          //this.$message.success('查询成功！');
        })
        .catch(e => {
          this.$message.error(`查询失败 ${e.message}`)
        })
    },
    // 判断哪行可以选中
    selectableHandler(row, index) {
      // 已淘汰的人不可以分配任务
      if (row.shopHasProxyJobStatus == 300) {
        return false
      } else {
        return true
      }
    },
    // 计算待处理数
    handlerSum() {
      let count = 0
      this.taskData &&
        this.taskData.forEach(item => {
          item.agencyList &&
            item.agencyList.forEach(n => {
              if (n.shopHasProxyJobStatus == 100) {
                count++
              }
            })
        })
      this.$emit('handlerSum', count == 0 ? '' : count)
    }
  },
  watch: {
    recruitInfoDialogVisible(newVal) {
      if (newVal == false) {
        this.currentProxyTaskDetail = {}
        this.currentTaskStatus = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signup-proxy-wrapper {
  position: relative;
  min-height: calc(100vh - 400px);
  .signup-proxy {
    .work-card {
      border: 1px solid #d8d8d8;
      border-radius: 2px;
      .input-group {
        .el-input,
        .el-select {
          margin-right: 12px;
        }
      }
    }

    // dialog 样式
    .dialog-content-top {
      .content-top-title {
        position: relative;
        .imgDiv {
          width: 101px;
          height: 90px;
          position: absolute;
          top: 20%;
          right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .content-top-info {
        .wj-count {
          margin-left: 14px;
        }
        .work-detail {
          margin-left: 28px;
        }
        .el-row {
          @apply my-4;
        }
        .grid-content {
          @apply text-theme-black-850;
          span {
            @apply text-medium text-theme-black-450;
          }
        }
      }
    }

    .dialog-content-bottom {
      @apply mt-9;
    }
  }
}
.status-text {
  div {
    @apply text-small;
    height: 22px;
    border-radius: 2px;
    color: #fff;
    font-weight: 500;
    text-align: center;
    padding: 1px 10px;
    line-height: 22px;
  }
}
.left-name {
  position: relative;
  top: 12px;
  max-width: 700px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 25px;
}
.right-content {
  position: relative;
  top: 5px;
}
::v-deep .el-drawer__body {
  position: relative;
}
.btn-footer {
  @apply h-16 flex items-center justify-end pr-6;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
